export const mapCloudCurrenciesToCurrencies = (cloudSettings?: {
  cloudCurrencies?: unknown
  currencies?: unknown
  [key: string]: unknown
}) => {
  if (cloudSettings?.cloudCurrencies !== undefined) {
    cloudSettings.currencies = cloudSettings.cloudCurrencies
    delete cloudSettings.cloudCurrencies
  }
}
